import { LoadingSpinnerPanel } from '@frontend/web-react/components/Primitives/Loading/LoadingSpinnerPanel';
import { createFileRoute } from '@frontend/web/utils/router';
import { lazy, Suspense } from 'react';

const LazyMCPComplete = lazy(() => import('./-mcp-complete').then((module) => ({ default: module.MCPComplete })));

const MCPCompleteRouteComponent = () => (
  <Suspense fallback={<LoadingSpinnerPanel fullScreen />}>
    <LazyMCPComplete />
  </Suspense>
);

export const Route = createFileRoute('/signup/mcp/complete')({
  component: MCPCompleteRouteComponent,
});
